import { render, staticRenderFns } from "./borrowingReturnIndex.vue?vue&type=template&id=20979aa5&scoped=true&"
import script from "./borrowingReturnIndex.vue?vue&type=script&lang=js&"
export * from "./borrowingReturnIndex.vue?vue&type=script&lang=js&"
import style0 from "./borrowingReturnIndex.vue?vue&type=style&index=0&id=20979aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20979aa5",
  null
  
)

export default component.exports